import { render, staticRenderFns } from "./DashboardPerusahaan.vue?vue&type=template&id=a7b9f95c"
import script from "./DashboardPerusahaan.vue?vue&type=script&lang=js"
export * from "./DashboardPerusahaan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSeparator,QAvatar,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSeparator,QAvatar,QIcon})
